import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const NewExperienceBannerActions = createActionGroup({
  source: 'New Experience Banner',
  events: {
    'Dismiss Clicked': emptyProps(),
    'Learn More Clicked': emptyProps(),
    'Try New Experience Clicked': props<{
      source: 'banner' | 'nav' | 'dialog';
    }>(),
    'Dismissed At Loaded': props<{ dismissedAt: string | null }>(),
  },
});

export const NewExperienceApiActions = createActionGroup({
  source: 'New Experience API',
  events: {
    'User Preferences Loaded': props<{ useReactUi?: boolean }>(),
    'User Preferences Load Failure': props<{ error: string }>(),
    'User Preference Updated': emptyProps(),
    'User Preference Update Failure': props<{ error: string }>(),
  },
});
